import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import NextImage from 'common/components/NextImage';
import Container from 'common/components/UI/Container';
import { Col, Grid, Box, List, ThemeIcon } from '@mantine/core';
import TeamSectionWrapper from './teamSection.style';
import { IconCircleDashed } from '@tabler/icons-react';

export interface TeamMember {
  id: number;
  name: string;
  designation: string;
  infos: string[];
  avatar_url: string;
  social_icon?: string;
}

export interface TeamSectionProps {
  sectionSubTitleText?: string;
  teamList: TeamMember[];
}

const TeamSection = ({ sectionSubTitleText, teamList }: TeamSectionProps) => (
  <TeamSectionWrapper id="testimonial_section">
    <Container>
      {sectionSubTitleText && (
        <Heading as="h1" content={sectionSubTitleText} />
      )}
      <Grid justify="flex-start" align="flex-start" columns={2}>
        {teamList.map((item) => (
          <Col md={1} sm={2} key={item.id}>
            <Box style={{ backgroundColor: '#f8f8f8', padding: 20, borderRadius: 20 }}>
              <Grid grow columns={2} justify="left" align="flex-start">
                <NextImage
                  src={item.avatar_url}
                  alt="Member Image"
                  height={200}
                  style={{ marginRight: 10, marginLeft: 20, marginTop: 20, borderRadius: 20 }}
                />
                <Grid.Col sm={1} xs={2}>
                  <Heading as="h1" content={item.name} mb={0} />
                  <Text content={item.designation} />
                  <List
                    spacing="xs"
                    icon={
                      <ThemeIcon color="teal" size={14} radius="xl">
                        <IconCircleDashed size={16} />
                      </ThemeIcon>
                    }
                  >
                    {item.infos.map((info, infoIdx) => (
                      <List.Item key={infoIdx} style={{ fontSize: 14 }}>
                        {info}
                      </List.Item>
                    ))}
                  </List>
                </Grid.Col>
              </Grid>
            </Box>
          </Col>
        ))}
      </Grid>
    </Container>
  </TeamSectionWrapper>
);

export default TeamSection;
